<template>


    <main class="">

        <div class="container my-5">

            <h1 class="my-5">Materiallager</h1>

            <form action="" class="mb-4">
                <div class="input-group input-group-lg">
                    <input type="search" class="form-control">
                        <button type="submit" class="btn btn-primary">Suche</button>
                </div>
            </form>

            <div class="d-grid gap-4">

                <div class="bg-white shadow-sm p-3" v-for="product in products">
                    <div class="row align-items-center">
                        <div class="col-1">
                            <img :src="product.image" class="" alt="" style="height: 80px; max-width: 100%;">        
                        </div>
                        <div class="col-3">
                            <h3 class="fs-5 m-0">
                                <a href="product.php" class="text-decoration-none">
                                    {{ product.name }}
                                </a>
                            </h3>
                            <div class="mt-2 small">
                                {{ product.supplier_pid }}
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="text-uppercase small text-secondary">Einheiten</div>
                            <div>3</div>
                        </div>
                        <div class="col-2">
                            <div class="text-uppercase small text-secondary">Ablaufdatum</div>
                            <div>24.02.2024</div>
                        </div>
                        <div class="col-4">
                            <a href="" class="btn btn-primary">Bearbeiten</a>
                            <a href="" class="btn btn-secondary">Wareneingang</a>
                            <a href="" class="btn btn-success">Nachbestellen</a>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </main>

</template>

<script>
    export default {
        props: [
            'products'
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>